import { DefaultButton, IPanelProps, IRenderFunction, Panel, PanelType, PrimaryButton, Stack, TextField, Toggle } from "@fluentui/react";
import CESDropdown from "components/controls/CESDropdown";
import SectionItem, { ESectionItemVariant } from "components/controls/SectionItem/Index";
import { panelButtonsStyles } from "global/Application";
import { useApplication } from "global/Application/Context";
import { useEffect, useState } from "react";
import {
    IDepartment as FAM_IDepartment
} from "../../model/FlexibleAttributeModel";

interface IProps {
    isOpen?: boolean;
    onCancel?: () => void;
    onDismiss?: () => void;
    department?: FAM_IDepartment
    onConfirm?: (department: FAM_IDepartment) => void;
    disabled?: boolean;
}

const GroupStructureDepartmentEditor: React.FunctionComponent<IProps> = (props) => {

    const application = useApplication();

    const [department, setDepartment] = useState<FAM_IDepartment | null>(
        props.department
            ? props.department
            : null
    );

    useEffect(() => {
        if (props.department)
            setDepartment(props.department);
    }, [props.department])


    const onRenderUnknown = () => {
        return <div>Unknown View.</div>
    }

    const onRenderBody: IRenderFunction<IPanelProps> = (bodyProps, defaultRender) => {
        if (!department)
            return onRenderUnknown();

        return <SectionItem title="Properties" variant={ESectionItemVariant.Drawer}>
            <Stack tokens={{ childrenGap: '15px' }}>
                <CESDropdown
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.department.link_ces}
                    value={department.cesNumberRef ? { id: department.cesNumberRef.id, cesNumber: department.cesNumberRef.name, deactivated: false } : undefined}
                    onChange={(option) => {
                        setDepartment(t => { return { ...t!, cesNumberRef: { id: option.id, name: option.cesNumber } } });
                    }}
                />
                <TextField
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.department.modify}
                    label="Department"
                    value={department.name ?? ''}
                    onChange={(event, newValue) => {
                        setDepartment(t => { return { ...t!, name: newValue ?? null } });
                    }}
                />
                <TextField
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.department.modify}
                    label="Description"
                    value={department.description ?? ''}
                    onChange={(event, newValue) => {
                        setDepartment(t => { return { ...t!, description: newValue ?? null } });
                    }}
                />

                <Toggle
                    label={"Deactivate"}
                    disabled={props.disabled || !application.ChangeTypePermissions.groupStructure.department.modify_deactivate}
                    checked={department.deactivated ?? false}
                    onChange={(_, checked) => {
                        setDepartment(t => { return { ...t!, deactivated: checked ?? false }; });
                    }}
                />
            </Stack>
        </SectionItem>
    }

    const onRenderFooter: IRenderFunction<IPanelProps> = (footerProps, defaultRender) => {
        if (!department)
            return onRenderUnknown();

        return <>
            <PrimaryButton text='Continue'
                styles={panelButtonsStyles}
                onClick={async () => {
                    props.onConfirm?.(department);
                    props.onDismiss?.();
                }}
            />

            <DefaultButton text='Cancel'
                styles={panelButtonsStyles}
                onClick={async () => {
                    props.onCancel?.();
                }}
            />
        </>
    }

    return <Panel
        isOpen={props.isOpen}
        onDismiss={props.onCancel}
        type={PanelType.medium}
        layerProps={{ eventBubblingEnabled: true }}
        isLightDismiss
        headerText="Manage | Group Structure"
        onRenderFooterContent={onRenderFooter}
        isFooterAtBottom={true}
    >
        {onRenderBody()}
    </Panel>
}

export default GroupStructureDepartmentEditor;